import { render, staticRenderFns } from "./TicketComment.vue?vue&type=template&id=5e5ebab9&scoped=true"
import script from "./TicketComment.vue?vue&type=script&lang=js"
export * from "./TicketComment.vue?vue&type=script&lang=js"
import style0 from "./TicketComment.vue?vue&type=style&index=0&id=5e5ebab9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ebab9",
  null
  
)

export default component.exports